<template>
  <nav class="nav-container">
    <div class="nav-content">
      <div class="logo-wrapper">
        <a href="/" class="logo-link">
          <img src="@/assets/img/logo.png" class="logo-img" alt="logo">
          <span class="brand-name hidden-xs">tnbapp</span>
        </a>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'LoginBar',
  data() {
    return {
    }
  }
}
</script>

<style scoped>
.nav-container {
  width: 100%;
  height: 60px;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  /* 默认保持绝对定位，在 PC 端悬浮感更强 */
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  box-sizing: border-box;
}

.nav-content {
  width: 100%;
  max-width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo-img {
  width: 32px;
  height: 32px;
  transition: transform 0.3s;
}

.brand-name {
  font-size: 18px;
  font-weight: 700;
  color: #303133;
  margin-left: 10px;
  letter-spacing: 0.5px;
}

.nav-link {
  text-decoration: none;
  color: #606266;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 20px;
  transition: all 0.3s;
}

.nav-link:hover {
  background-color: rgba(64, 158, 255, 0.1);
  color: #409EFF;
}

/* 适配逻辑 */
@media screen and (max-width: 768px) {
  .nav-container {
    height: 54px;
    /* 移动端改为相对定位，避免盖住下方的 Login 卡片 */
    position: relative;
    background-color: #fff; /* 移动端给个白底，更清晰 */
    box-shadow: 0 1px 4px rgba(0,0,0,0.05);
  }

  .hidden-xs {
    display: none; /* 核心适配：在手机端隐藏文字 */
  }

  .logo-img {
    width: 28px;
    height: 28px;
  }

  .nav-link {
    padding: 6px; /* 缩小点击区域边距 */
  }

  .nav-link i {
    font-size: 20px; /* 图标稍微加大，方便手指点击 */
  }
}
</style>
